
import map from 'lodash/map';
import get from 'lodash/get';
import { selectCurrentUser } from './user';
import { createSelector } from 'reselect';


export const projectSelector = (project, currentUser) => project && {...project, is_owner: get(project, 'account.id') === get(currentUser, 'account.id')}
export const selectProjects = (state) => state.projects
export const selectCurrentProject = (state) => state.currentProject


export const projectsSelector = createSelector(
  [selectCurrentUser, selectProjects],
  (currentUser, projects) => map(projects, (project) => projectSelector(project, currentUser))
)

export const myProjectsSelector = createSelector(
  projectsSelector,
  (projects) => projects.filter(p => p.is_owner)
)

export const sharedProjectsSelector = createSelector(
  projectsSelector,
  (projects) => projects.filter(p => !p.is_owner)
) 


// WEBPACK FOOTER //
// ./src/reducers/selectors/projects.js